// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CsZN","tabsBox":"styles_tabsBox__KTE5p","createButton":"styles_createButton__18aWS"};